
import end2 from '@/views/end/end2.vue';

export default {
  path: '/end',
  component: {
    render(c) { return c('router-view'); }
  },
  children: [

    {
      path: 'end2',
      name: 'end2',
      component: end2
    },

  ]
};
